import { Component, Input, OnInit  } from '@angular/core';

@Component({
  selector: 'app-common-loader',
  styleUrls: ['./common-loader.component.scss'],
  template: `<div class="pageLoader">
    <div class="layoutLoader">
      <h3>Please Wait...</h3>
      <div class="loaderContent">
        <div class="springLoader">
          <mat-spinner [diameter]="48"></mat-spinner>
        </div>
        <p>{{ content }}</p>
        <!-- <p> Under Progress...</p> -->
      </div>
    </div>
  </div>`
})
export class CommonLoaderComponent implements OnInit {
  @Input() content: string = ''; // Input to hold dynamic content
  constructor() { }

  ngOnInit(): void { }

}
